var React = require('react');

function DeveloperTools (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 8.8a1.52 1.52 0 0 0-.77-1.33l-6.46-3.26a1.57 1.57 0 0 0-1.54 0L4.77 7.47A1.52 1.52 0 0 0 4 8.8v7.46a1.52 1.52 0 0 0 .77 1.33l4.79 2.3a1.05 1.05 0 0 0 1.51-.95v-3.45h-.55a2.8 2.8 0 0 1-2.74-2.8v-1.16a2.8 2.8 0 0 1 2.81-2.81v2.65A1.41 1.41 0 0 0 12 12.78a1.41 1.41 0 0 0 1.41-1.41V8.71a2.81 2.81 0 0 1 2.81 2.82v1.16a2.8 2.8 0 0 1-2.74 2.8h-.55v3.45a1.05 1.05 0 0 0 1.51.95l4.79-2.3a1.52 1.52 0 0 0 .77-1.33Z","fill":"#001b35"}));
}

DeveloperTools.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = DeveloperTools;

DeveloperTools.default = DeveloperTools;
